module.exports = "/_next/static/images/emptyCategory-536b00e02d8dba618f9224959324a862.webp";